import { IdIndexedUserGroups, UserGroup } from 'data/userGroups/types'
import { FinderStageId, Stage } from 'entities-next/stages'
import { PairingStageFilter } from 'scenes/Dashboard/components/PairingStageFilter'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { ActionType, createAction, createAsyncAction, createStandardAction } from 'typesafe-actions'

import { CorporateStatusFilter, IsValidFilter } from './types'
import { IdIndexedCorporate } from '../../../../../entities-next/corporate'

export const loadData = createAction('/scenes/Dashboard/scenes/DealManager/LOAD_DATA')

export const unMountPairingManager = createAction('/scenes/Dashboard/scenes/DealManager/UNMOUNT_DEAL_MANAGER')

export const updateDealFinderStage = createAsyncAction(
  '/scenes/Dashboard/scenes/DealManager/DEAL_FINDER_STAGE_UPDATE_BEGIN',
  '/scenes/Dashboard/scenes/DealManager/DEAL_FINDER_STAGE_UPDATE_SUCCESS',
  '/scenes/Dashboard/scenes/DealManager/DEAL_FINDER_STAGE_UPDATE_FAILURE'
)<{ dealId: Deal['id']; newStage: Stage['id'] }, Deal, Error>()

export const fetchManagerPairings = createAsyncAction(
  '/scenes/Dashboard/scenes/DealManager/FETCH_DRAFT_DEALS_BEGIN',
  '/scenes/Dashboard/scenes/DealManager/FETCH_DRAFT_DEALS_SUCCESS',
  '/scenes/Dashboard/scenes/DealManager/FETCH_DRAFT_DEALS_FAILURE',
  '/scenes/Dashboard/scenes/DealManager/FETCH_DRAFT_DEALS_CANCEL'
)<undefined, Deal[], Error, undefined>()

export const fetchDraftUsers = createAsyncAction(
  '/scenes/Dashboard/scenes/DealManager/FETCH_USERS_BEGIN',
  '/scenes/Dashboard/scenes/DealManager/FETCH_USERS_SUCCESS',
  '/scenes/Dashboard/scenes/DealManager/FETCH_USERS_FAILURE'
)<{ userIds: Deal['userId'][] }, IdIndexedCorporate, Error>()

export const fetchDraftUserGroups = createAsyncAction(
  '/scenes/Dashboard/scenes/DealManager/FETCH_USER_GROUPS_BEGIN',
  '/scenes/Dashboard/scenes/DealManager/FETCH_USER_GROUPS_SUCCESS',
  '/scenes/Dashboard/scenes/DealManager/FETCH_USER_GROUPS_FAILURE'
)<{ userGroupIds: UserGroup['id'][] }, IdIndexedUserGroups, Error>()

export const resetFilters = createAction('/scenes/Dashboard/scenes/DealManager/REUPDATE_FILTERS')

export const updateOrganizationFilter = createStandardAction(
  '/scenes/Dashboard/scenes/DealManager/UPDATE_ORGANIZATION_FILTER'
)<string>()

export const updateFinderStagesFilter = createStandardAction(
  '/scenes/Dashboard/scenes/DealManager/UPDATE_FINDER_STAGES_FILTER'
)<PairingStageFilter[]>()

export const updateCorporateFilter = createStandardAction(
  '/scenes/Dashboard/scenes/DealManager/UPDATE_USER_FILTER'
)<string>()

export const updateSearchRequestIdFilter = createStandardAction(
  '/scenes/Dashboard/scenes/DealManager/UPDATE_SEARCH_REQUEST_ID'
)<string>()

export const updateCorporateStatusFilter = createStandardAction(
  '/scenes/Dashboard/scenes/DealManager/UPDATE_CORPORATE_STATUS_FILTER'
)<CorporateStatusFilter>()

export const updateIsValidFilter = createStandardAction(
  '/scenes/Dashboard/scenes/DealManager/UPDATE_IS_VALID_FILTER'
)<IsValidFilter>()

export const updateSearchCount = createStandardAction(
  '/scenes/Dashboard/scenes/DealManager/UPDATE_SEARCH_COUNT'
)<number>()

export const updateCurrentPage = createStandardAction(
  '/scenes/Dashboard/scenes/DealManager/UPDATE_CURRENT_PAGE'
)<number>()

export const promoteDeal = createAsyncAction(
  '/scenes/Dashboard/scenes/DealManager/PROMOTE_DEAL_BEGIN',
  '/scenes/Dashboard/scenes/DealManager/PROMOTE_DEAL_SUCCESS',
  '/scenes/Dashboard/scenes/DealManager/PROMOTE_DEAL_FAILURE'
)<{ dealId: Deal['id']; nextFinderStage: FinderStageId }, Deal, Error>()

export const toggleHoldDeal = createAsyncAction(
  '/scenes/Dashboard/scenes/DealManager/TOGGLE_HOLD_DEAL_BEGIN',
  '/scenes/Dashboard/scenes/DealManager/TOGGLE_HOLD_DEAL_SUCCESS',
  '/scenes/Dashboard/scenes/DealManager/TOGGLE_HOLD_DEAL_FAILURE'
)<{ dealId: Deal['id']; onHold: boolean }, Deal, Error>()

export const demoteDeal = createAsyncAction(
  '/scenes/Dashboard/scenes/DealManager/DEMOTE_DEAL_BEGIN',
  '/scenes/Dashboard/scenes/DealManager/DEMOTE_DEAL_SUCCESS',
  '/scenes/Dashboard/scenes/DealManager/DEMOTE_DEAL_FAILURE'
)<Deal['id'], Deal, Error>()

export const deleteDeal = createAction('/scenes/Dashboard/scenes/DealManager/DELETE_DEAL', (resolve) => (deal: Deal) =>
  resolve(deal)
)

export const releaseDealToInvestor = createAsyncAction(
  '/scenes/Dashboard/scenes/DealManager/RELASE_TO_INVESTOR_BEGIN',
  '/scenes/Dashboard/scenes/DealManager/RELASE_TO_INVESTOR_SUCCESS',
  '/scenes/Dashboard/scenes/DealManager/RELASE_TO_INVESTOR_FAILURE'
)<Deal['id'], Deal, Error>()

export type DealManagerAction = ActionType<
  | typeof loadData
  | typeof unMountPairingManager
  | typeof fetchManagerPairings
  | typeof resetFilters
  | typeof updateOrganizationFilter
  | typeof updateCorporateFilter
  | typeof updateSearchRequestIdFilter
  | typeof updateSearchCount
  | typeof updateCurrentPage
  | typeof updateFinderStagesFilter
  | typeof fetchDraftUsers
  | typeof fetchDraftUserGroups
  | typeof promoteDeal
  | typeof demoteDeal
  | typeof deleteDeal
  | typeof updateIsValidFilter
  | typeof updateCorporateStatusFilter
  | typeof toggleHoldDeal
  | typeof releaseDealToInvestor
>
